module.exports = __webpack_public_path__ + "media/images/call-center-95aab8722b00820c9b47053e872b16be.svg";